/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { claimService } from '../../../../api/services/claimService';
import { useAppSelector } from '../../../../infra/hooks';

interface PropsValue {
  setAllClaimTypes: (data: any) => void;
}
const DTOTransferReceiveARModal = ({ setAllClaimTypes }: PropsValue) => {
  const selector = useAppSelector((state) => state.authSlice);

  async function getAllClaimTypes(company_id: number) {
    const respose: any = await claimService.getAllClaimTypes(company_id);
    if (respose) {
      setAllClaimTypes(respose?.data);
    }
  }

  useEffect(() => {
    if (selector.company_id) getAllClaimTypes(selector.company_id);
  }, []);

  return <></>;
};

export default DTOTransferReceiveARModal;
